import { render, staticRenderFns } from "./gInfo.vue?vue&type=template&id=2c2db617&scoped=true&"
import script from "./gInfo.vue?vue&type=script&lang=js&"
export * from "./gInfo.vue?vue&type=script&lang=js&"
import style0 from "./gInfo.vue?vue&type=style&index=0&id=2c2db617&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2db617",
  null
  
)

export default component.exports